import _ from 'lodash'
import selectors from '../selectors'

function defaultHeaders(state: any) {
  return _.pickBy({
    'Content-Type': 'application/json',
    'Authorization' : localStorage.getItem('jwt.access_token') as string|null,
    'X-GOGOVAPPS-SITE': selectors.site(state).site
  }, _.identity);
}

export default {
  defaultHeaders
}
